import { CornerStyle } from '../../types';

export const HUB_CORNER_RADIUS_MIN = 0;
export const HUB_CORNER_RADIUS_MAX = 32;
export const HUB_CORNER_RADIUS_STEP = 8;
export const HUB_CORNER_RADIUS_DEFAULT = 8;
export const HUB_CORNER_RADIUS_CSS_VAR = '--hub-corner-radius';

const VALID = new Set([0, 8, 16, 24, 32]);

/**
 * Coerce a stored corner-radius into a valid step. null/undefined (inherit) and
 * any non-step / out-of-range value resolve to the 8px default. The picker only
 * emits valid steps; this guards legacy / migrated / malformed values.
 */
export const resolveHubCornerRadius = (value: number | null | undefined): number =>
	typeof value === 'number' && VALID.has(value) ? value : HUB_CORNER_RADIUS_DEFAULT;

/** Map a legacy CornerStyle enum to a numeric radius for the gated path.
 * SQUARED → 0 (no radius); ROUNDED or undefined → undefined (inherit from hub). */
export const cornerStyleToRadius = (style?: CornerStyle): number | undefined =>
	style === CornerStyle.SQUARED ? 0 : undefined;
